import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { thunk } from "redux-thunk";

import { CLEAR_STORE } from "./types/auth.types";

import main from "./reducers/main.reducer";
import message from "./reducers/message.reducer";
import auth from "./reducers/auth.reducer";
import inventory from "./reducers/inventory.reducer";
import user from "./reducers/user.reducer";
import profile from "./reducers/profile.reducer";
import balance from "./reducers/balance.reducer";
import update from "./reducers/updates.reducer";
import help_center from "./reducers/help_center.reducer";
import orders from "./reducers/orders.reducer";
// Maintainers
import maintainers_products from "./reducers/maintainers/product.reducer";
import maintainers_business from "./reducers/maintainers/business.reducer";
import maintainers_estates from "./reducers/maintainers/estates.reducer";
import maintainers_users from "./reducers/maintainers/users.reducer";
import maintainers_operators from "./reducers/maintainers/operators.reducer";
import maintainers_species from "./reducers/maintainers/species.reducer";
import maintainers_varieties from "./reducers/maintainers/varieties.reducer";
import maintainers_quarters from "./reducers/maintainers/quarters.reducer";
import maintainers_business_center from "./reducers/maintainers/business_center.reducer";
import maintainers_machineries from "./reducers/maintainers/machineries.reducer";
import maintainers_incidents from "./reducers/maintainers/incidents.reducer";
import maintainers_categories from "./reducers/maintainers/categories.reducer";
import maintainers_dealers from "./reducers/maintainers/dealers.reducer";
import maintainers_balances from "./reducers/maintainers/balances.reducer";

const reducer = combineReducers({
	main,
	message,
	auth,
	inventory,
	user,
	profile,
	balance,
	update,
	help_center,
	orders,
	maintainers_products,
	maintainers_business,
	maintainers_estates,
	maintainers_users,
	maintainers_operators,
	maintainers_species,
	maintainers_varieties,
	maintainers_quarters,
	maintainers_business_center,
	maintainers_machineries,
	maintainers_incidents,
	maintainers_categories,
	maintainers_dealers,
	maintainers_balances,
});

const rootReducer = (state, action) => {
	if (action.type === CLEAR_STORE) return reducer(undefined, action);
	return reducer(state, action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const globalState = localStorage.getItem("GLOBAL_STATE");
const initialState = globalState ? JSON.parse(globalState) : undefined;
const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunk)));

export const saveState = () => {
	localStorage.setItem("GLOBAL_STATE", JSON.stringify(store.getState()));
};

export default store;
